<template class="page-content">
  <ModalLayout :ref="modalRef"
    modal-id="notFoundModal"
    :loading="false"
    modal-style="background-color: #000"
    @close="modalClosed()">
    <template #modal-header>
      <h5>Not Found</h5>
    </template>
    <template #modal-body>
      The requested item could not be found.

      <hr>
      <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="modalClosed">Close</button>
    </template>
  </ModalLayout>
</template>

<script>
import ModalLayout from "@/src/components/shared/ModalLayout.vue";

export default {
  components: {
    ModalLayout
  },
  props: {
    modalRef: { type: String, required: true },
  },
   data() {
    return {
      modalRef: 'notFoundModal'
    }
  },
  methods: {
    modalClosed() {
      this.$emit('close');
    },
  },
};
</script>
